module.exports = __webpack_public_path__ + "static/img/5.7bd1defc.png";